/* @flow */

import Edit from './Edit';
import View from './View';
import Render from './Render';

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;
export const getRenderComponent = () => Render;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/page/index.js